import { useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import PageContainer from '../../pageLayout/PageContainer';
import axiosInstance from '../../api/axiosInstance';
import { AuthBox, AuthLayout1 } from '../registerModal/Register2Style';
import logo_horizontal from '../../img/teachernote-logo/teachernote-logo-horizontal.png';
import { AuthCardContainer } from '../../components/AuthCardContainer';
import Input from '../../components/StyledInput';
import MainButton from '../../components/MainButton';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { ResetPasswordHelmetContent } from '../../components/HelmetContent';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // URL에서 token 추출

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      return setMessage('비밀번호가 일치하지 않습니다.');
    }

    try {
      const response = await axiosInstance.post('/reset-password', {
        token,
        newPassword,
      });

      setMessage('비밀번호가 성공적으로 변경되었습니다. 다시 로그인해주세요.');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      console.error(err);
      setMessage('토큰이 유효하지 않거나 만료되었습니다.');
    }
  };

  return (
    <PageContainer>
      <ResetPasswordHelmetContent />
      <AuthBox>
        <AuthLayout1>
          <div>
            <img
              src={logo_horizontal}
              style={{ width: '300px' }}
              alt="티처노트 로고 - 가로형"
            />
          </div>
          비밀번호를 다시 설정해주세요!
        </AuthLayout1>
        <AuthCardContainer className="reset-password-container">
          <form onSubmit={handleSubmit}>
            <Input
              type="password"
              placeholder="새 비밀번호"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <Input
              type="password"
              placeholder="비밀번호 확인"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <MainButton type="submit">비밀번호 변경</MainButton>
          </form>
          {message && <p>{message}</p>}
        </AuthCardContainer>
      </AuthBox>
    </PageContainer>
  );
};

export default ResetPassword;
